import React from "react";
import { useLocation } from "react-router-dom";

import { ConfigContext } from "@app/provider";
import { useQuery } from "@app/utils";
import { LoadingContext } from "@natera/platform/lib/components/context";
import { redirectTo } from "@app/utils";

export const billingPath = "/billing";
export const pricingGeneticTestingPath = "/pricing/genetic_testing";
export const requestMobilePhlebotomyPath =
  "/services/request_mobile_phlebotomy";

const RedirectLPP: React.FC = () => {
  const { config } = React.useContext(ConfigContext);
  const query = useQuery();
  const location = useLocation();

  React.useEffect(() => {
    const path = location.pathname.replace(/(.)\/$/, "$1");
    const queryString = query.toString();
    const urlQuery = queryString ? `?${queryString}` : "";

    const legacyPpRoute = config.patientPortal.url;

    let redirectToUrl;
    switch (path) {
      case billingPath:
        redirectToUrl = config.links.WOMENS_HEALTH_PRICING_BILLING;
        break;
      case requestMobilePhlebotomyPath:
        redirectToUrl = config.links.WOMENS_HEALTH_DRAW_REQUEST;
        break;
      default:
        redirectToUrl = `${legacyPpRoute}${path}`;
    }

    redirectToUrl += urlQuery;

    redirectTo(redirectToUrl);
  }, []);

  return <LoadingContext isLoading />;
};

export default RedirectLPP;
